export const SHOW_NOTIFY_GUESTS_OVERLAY = '/modals/NotifyGuestsOverlay/show';
export const HIDE_NOTIFY_GUESTS_OVERLAY = '/modals/NotifyGuestsOverlay/hide';
export const CANCEL_NOTIFY_GUESTS_OVERLAY = '/modals/NotifyGuestsOverlay/cancel';
export const SET_UPSELL_MODAL_ORDER = '/modals/Upsell/setOrder';
export const SET_UPSELL_CONFIRMED = '/modals/Upsell/SetUpsellConfirmed';
export const SET_SHOW_LEAVE_MODAL = '/modals/Upsell/SetShowLeaveModal';
